import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'
import { Tooltip, calculateContractlength, getPersonAgeByContractDate, getPersonTypeByAge, getContractStartDate, ssnIsUSABorn } from '../../utils'
import CurrencyFormat from 'react-currency-format';
import StartDateOptions from '../start-date-options'
import InsuranceTaker from '../insurance-taker'
import KomfortDynamicGuaranteedCapitalForm from '../komfort-dynamik-guaranteed-capital-form'

const kennitala = require('kennitala')

class RentenForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                age: '',
                ageContractEnd: '',
                monthlyinsurance: '',
                deathbenefits: '',
                insurancetaker: '',
                beneficiary: '',
            }
        }

        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.age = React.createRef()
        this.ageContractEnd = React.createRef()
        this.monthlyinsurance = React.createRef()
        this.deathbenefits = React.createRef()
    }

    componentDidMount () {
        if (this.props.initialValues['RENcontractstartdate'] === undefined) {
            this.props.dispatch(setInfoKey({key: "RENcontractstartdate", value: getContractStartDate("REN").format("D.M.YYYY")}, this.props.customerId))
        }

        let info = kennitala.info(this.props.customerId)
        if (info.age > 17) {
            this.props.dispatch(setInfoKey({key: "RENinsuranceTaker", value: this.props.customerId}, this.props.customerId))
        }

        const isUSABorn = ssnIsUSABorn(this.props.customerId, this.props); 
        if (isUSABorn) {
            this.props.dispatch(setInfoKey({key: "RENPortfolio", value: 'perspektive'}, this.props.customerId))
        }

    }

    validateForm() {
        let errors = this.state.errors
        let valid = true;
        Object.keys(errors).forEach(key => {
            switch (key) {
                case 'age':
                    let ageValue = this.props.initialValues["age"];
                    if (parseInt(ageValue) < 0) {
                        errors.age = 'Að lágmarki 0'
                        valid = false;
                    } else if (parseInt(ageValue) > 80) {
                        errors.age = 'Að hámarki 80'
                        valid = false;
                    } else {
                        errors.age = ''
                    }
                    break;
                case 'ageContractEnd':
                    let ageContractEndValue = this.ageContractEnd.current.value;

                    let contractLength = calculateContractlength(this.props.customerId, ageContractEndValue, this.props.initialValues["RENcontractstartdate"])
                    let contractIsOneTime = this.props.initialValues['RENtype'] === 'onetime';

                    // Contracts are generally 5 years mininum, but 2 years for one-time contracts
                    let minContractLength = 5;
                    if (contractIsOneTime) {
                        minContractLength = 2;
                    }
                    
                    // KomfortDynamik contracts are generally 10 years minimum, but 5 years for one-time contracts
                    if (this.props.initialValues["RENPortfolio"].toLowerCase() === "komfortdynamik") {
                        minContractLength = 10;
                        if (contractIsOneTime) {
                            minContractLength = 5;
                        }
                    }

                    if (contractLength < minContractLength && parseInt(ageContractEndValue) > 0) {
                        errors.ageContractEnd = `Samningur að lágmarki ${minContractLength} ár`
                        valid = false;
                    } else if (ageContractEndValue > 85) {
                        errors.ageContractEnd = 'Að hámarki 85'
                        valid = false;
                    } else if (ageContractEndValue === '') {
                        errors.ageContractEnd = 'Skilyrði að fylla út'
                        valid = false;
                    } else {
                        errors.ageContractEnd = ''
                    }
                    break;

                case 'monthlyinsurance':
                    let monthlyinsuranceValue = this.props.initialValues["RENpayment"];
                    if (this.props.initialValues["RENtype"] === "monthly") {
                        if (parseInt(monthlyinsuranceValue) < 25) {
                            errors.monthlyinsurance = 'Að lágmarki 25 €'
                            valid = false;
                        } else if (monthlyinsuranceValue === '' || monthlyinsuranceValue == undefined) {
                            errors.monthlyinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.monthlyinsurance = ''
                        }
                    } else if (this.props.initialValues["RENtype"] === "onetime") {
                        if (monthlyinsuranceValue === '' || monthlyinsuranceValue == undefined) {
                            errors.monthlyinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.monthlyinsurance = ''
                        }
                    } else {
                        if (parseInt(monthlyinsuranceValue) < 3000) {
                            errors.monthlyinsurance = 'Að lágmarki 3.000 €'
                            valid = false;
                        } else if (monthlyinsuranceValue === '' || monthlyinsuranceValue == undefined) {
                            errors.monthlyinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.monthlyinsurance = ''
                        }
                    }
                    break;

                case 'deathbenefits':
                    if (this.props.initialValues["RENdeathbenefits"] === true) {
                        let deathbenefitsValue = this.deathbenefits.current.value;
                        if (parseInt(deathbenefitsValue) < 100) {
                            errors.deathbenefits = 'Að lágmarki 100%';
                            valid = false
                        } else if (parseInt(deathbenefitsValue) > 400) {
                            errors.deathbenefits = 'Að hámarki 400%';
                            valid = false
                        } else if (deathbenefitsValue === '') {
                            errors.deathbenefits = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.deathbenefits = ''
                        }
                    } else {
                        errors.deathbenefits = ''
                    }
                    break;

                case 'insurancetaker':
                    let insuranceTakerValue = this.props.initialValues['RENinsuranceTaker'];
                    if (insuranceTakerValue === undefined || insuranceTakerValue === "") {
                        errors.insurancetaker = 'Velja þarf tryggingartaka'
                        valid = false;
                    } else {
                        errors.insurancetaker = ''
                    }
                    break;

                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.checked }, this.props.customerId, this.props.formType))
    }

    onChangeTextInput(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId, this.props.formType))
    }

    onChangeLargeNumberInput(value, name) {
        this.props.dispatch(setInfoKey({ key: name, value: value }, this.props.customerId))
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId, this.props.formType))
        if(event.target.name === 'RENPortfolio' && event.target.value === 'komfortdynamik' && this.props.initialValues['RENtype'] === 'insuranceamount') {
            this.props.dispatch(setInfoKey({ key: 'RENtype', value: 'monthly' }, this.props.customerId))
        }

    }
    onClickConfirm(event) {
        let validate = this.validateForm()

        if (this.props.isAdult && this.props.initialValues['RENinsuranceTaker'] === undefined) {
            this.props.dispatch(setInfoKey({ key: 'RENinsuranceTaker', value: this.props.customerId }, this.props.customerId))
        }
        if (validate) {
            Promise.resolve(this.props.dispatch(setInfoKey({ key: event.target.name, value: true }, this.props.customerId)))
                .then(() => {
                    this.props.onSuccess()
                })
        }
    }
    onClickChange(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    initialValuesConfirm(personType){
        const { initialValues } = this.props
        let confirm = ""
        if (personType === "child") {
            confirm = initialValues.forConfirm;
        } else {
            confirm = initialValues.renConfirm;
        }
        return confirm;
    }
    
    getPortfolioSelector(customerId, initialValues){
        let arr = ['KomfortDynamik', 'Perspektive']
        let personType = getPersonTypeByAge(this.props.customerId)
        const isUSABorn = ssnIsUSABorn(this.props.customerId, this.props); 
        const defaultvalue = (isUSABorn ?  'Perspektive' : initialValues["RENPortfolio"]).toLowerCase();
        return (
            <>   
            <select className="custom-select col-12 col-sm-6" id={`ren-portfolio-${customerId}`} name="RENPortfolio" onChange={this.onChangeSelectValue} value={defaultvalue} disabled={this.initialValuesConfirm(personType)} >
                { arr.map((val) => {
                    let disabled = false
                    if (val === 'KomfortDynamik') {
                        if (!window.KOMFORT_DYNAMIK_ENABLED || isUSABorn) {
                            disabled = true
                        }
                    }
                    return <option key={val} value={val.toLowerCase()} disabled={disabled}>{val}</option>
                })}
            </select>
            {isUSABorn
            ?
                <Tooltip placement="bottom" text={"Samkvæmt upplýsingum úr Þjóðskrá er tryggingartaki fæddur í Bandaríkjunum. Ekki er hægt að velja ávöxtunarleiðina KomfortDynamik. Nánari upplýsingar eru á innri.allianz.is."} />
            :
                <></>
            }
            </>
        )   
    }
    
    render() {
        const { customerId, customers, active, initialValues } = this.props
        let personType = getPersonTypeByAge(this.props.customerId)
        const contractAge = getPersonAgeByContractDate(customerId, initialValues["RENcontractstartdate"])
        const displayAge = contractAge !== null ? contractAge : initialValues["age"]

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.age.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ris-contract-age-${customerId}`} className="col-sm-8 col-form-label">
                            Samningsaldur
                            {this.state.errors.age.length > 0 ?
                                 <span className="error"> ({this.state.errors.age}) </span> : ''
                            }
                            <Tooltip placement="bottom" text={"Samningsaldur umsækjanda miðast við upphafsdag samnings.  Ef <strong>meira en 183 dagar</strong> eru liðnir frá síðasta afmæli á upphafsdegi er aldurinn námundaður upp um eitt ár."} />
                        </label>
                        <div className="col-sm-4">
                            <input id={`ris-contract-age-${customerId}`} name="contract-age" type="number" className="form-control px-2 text-sm-right" value={displayAge} disabled />
                            <input type="hidden" ref={this.age} id={`ris-age-${customerId}`} name="age" className="form-control px-2 text-sm-right" value={initialValues["age"]} />
                        </div>
                    </div>
                    <div className={`form-row align-items-center`}>
                        <label className="col-sm-8 col-form-label">
                            Upphaf samnings
                        </label>
                        <div className="col-sm-4 text-right">
                            <StartDateOptions
                                startDate={getContractStartDate("REN").format("D.M.YYYY")}
                                selectedDate={initialValues["RENcontractstartdate"]}
                                contractDateKey={"RENcontractstartdate"}
                                customerId={customerId}
                                disabled={this.initialValuesConfirm(personType)}
                                dispatch={this.props.dispatch}
                            />
                        </div>
                    </div>
                    <div className={`${this.state.errors.ageContractEnd.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ren-age-by-contract-end-${customerId}`} className="col-sm-8 col-form-label">
                            Aldur við lok samnings (ár)
                            {this.state.errors.ageContractEnd.length > 0 ?
                                <span className="error"> ({this.state.errors.ageContractEnd}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4">
                            <input ref={this.ageContractEnd} id={`ren-age-by-contract-end-${customerId}`} name="RENageByContractEnd" type="number" className="form-control text-sm-right px-2" onChange={this.onChangeTextInput} value={initialValues["RENageByContractEnd"]} disabled={this.initialValuesConfirm(personType)} />
                        </div>
                    </div>


                    <div className="form-row align-items-center">
                        <div className="col-sm-6">
                            <label htmlFor={`ren-portfolio-${customerId}`} className="col-sm-8 col-form-label">Ávöxtunarleið</label>
                        </div>
                        <div className="col-sm-6 text-right">
                            { this.getPortfolioSelector(customerId, initialValues) }
                        </div>
                    </div>

                    <KomfortDynamicGuaranteedCapitalForm customerId={customerId} initialValues={initialValues} disabled={initialValues.renConfirm} dispatch={this.props.dispatch} keyPrefix="REN" personType={personType} />

                    <div className="form-row align-items-center">
                        <label htmlFor={`ren-contract-length-${customerId}`} className="col-sm-8 col-form-label">Lengd samnings (ár)</label>
                        <div className="col-sm-4">
                            <input id={`ren-contract-length-${customerId}`} type="number" className="form-control text-sm-right px-2" onChange={this.onChangeTextInput} value={calculateContractlength(customerId, initialValues["RENageByContractEnd"], this.props.initialValues["RENcontractstartdate"])} disabled />
                        </div>
                    </div>
                    <div className={`${this.state.errors.monthlyinsurance.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <div className="col-sm-6">
                            <select className="custom-select  col-12 col-sm-8" id={`ren-type-${customerId}`} name="RENtype" onChange={this.onChangeSelectValue} value={initialValues["RENtype"]} disabled={this.initialValuesConfirm(personType)} >
                                <option value="monthly">Iðgjald</option>
                                {initialValues["RENPortfolio"] !== "komfortdynamik" && <option value="insuranceamount">Tryggður höfuðstóll</option>}
                                <option value="onetime">Eingreiðsla</option>
                            </select>
                            {this.state.errors.monthlyinsurance.length > 0 ?
                                <span className="error"> ({this.state.errors.monthlyinsurance}) </span> : ''
                            }
                        </div>

                        <div className="col-sm-6 col-12 text-right currency">
                            <CurrencyFormat
                                ref={this.monthlyinsurance}
                                thousandSeparator={"."}
                                id={`ren-payment-${customerId}`}
                                name="RENpayment"
                                type="text"
                                className="form-control"
                                value={initialValues["RENpayment"]}
                                disabled={this.initialValuesConfirm(personType)}
                                decimalSeparator={','}
                                onValueChange={(values) => {
                                    const { value } = values;
                                    this.onChangeLargeNumberInput(value, "RENpayment")
                                }}
                            />
                            {initialValues["RENtype"] === "monthly" && <div>Lágmarksgjald 25€</div>}
                            {initialValues["RENtype"] === "insuranceamount" && <div>Lágmarkshöfuðstóll 3.000€</div>}
                            {initialValues["RENtype"] === "onetime" && <div></div>}
                        </div>
                    </div>
                    
                    { initialValues['RENtype'] !== "onetime" && displayAge >= 7 &&

                    <div className={`${this.state.errors.deathbenefits.length > 0 ? 'error' : ''} form-row checkbox-row align-items-center`}>
                        <div className="col-8">
                            <div className="col-form-label"><label className="caption-label" htmlFor={`ren-deathbenefits-${customerId}`}>
                                Dánarbætur vegna slyss
                                {this.state.errors.deathbenefits.length > 0 ?
                                    <span className="error"> ({this.state.errors.deathbenefits}) </span> : ''
                                }
                            </label></div>
                            <input type="checkbox" id={`ren-deathbenefits-${customerId}`} name="RENdeathbenefits" onChange={this.onChangeCheckbox} checked={initialValues["RENdeathbenefits"]} disabled={this.initialValuesConfirm(personType)} />
                            <label htmlFor={`ren-deathbenefits-${customerId}`} className="col-sm-10 col-form-label"></label>
                        </div>
                        {initialValues["RENdeathbenefits"] === true &&
                            <div className="col-4 percentage">
                                <input ref={this.deathbenefits} id={`ren-death-insurance-${customerId}`} name="RENdeath-insurance" type="text" className="form-control" onChange={this.onChangeTextInput} value={initialValues["RENdeath-insurance"]} disabled={this.initialValuesConfirm(personType)} />
                                { initialValues.RENPortfolio.toLowerCase() === "komfortdynamik" ?
                                    <div className="text-right"><small>Hlutfall af iðgjaldasummu</small></div> 
                                    :
                                    <div className="text-right"><small>Hlutfall af tryggðum höfuðstól</small></div> 
                                }
                            </div>
                        }
                    </div>}

                    <InsuranceTaker 
                        fieldName={`RENinsuranceTaker`} 
                        customerId={customerId} 
                        initialValues={initialValues}
                        errors={this.state.errors.insurancetaker} 
                        disabled={this.initialValuesConfirm(personType)}
                    />

                </form>
                <div className="col-12 text-right button-container">
                    {this.initialValuesConfirm(personType) ?
                        (<button className="btn btn-primary xs-m-10" name={personType === "child" ? "forConfirm" : "renConfirm"} onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name={personType === "child" ? "forConfirm" : "renConfirm"} onClick={this.onClickConfirm}> Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default RentenForm